import React, { useCallback, useEffect, useState, useRef, forwardRef } from "react";
// import { ChevronRightIcon } from "@heroicons/react/solid";
// import { ExpandIcon } from "../../../components";
import AnnouncementItem from "./AnnouncementItem";
import AnnouncementModalItem from "./AnnouncementModalItem";
import { XIcon } from "@heroicons/react/outline";
import { useAxios } from "../../../hooks";

const Announcements = forwardRef(({ onDataLoaded, disableModal = false }, ref) => {
  const { axiosInstance, idToken } = useAxios();
  const [readIds, setReadIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [announcements, setAnnouncements] = useState([]);

  const [readAnnouncementIds, setReadAnnouncementIds] = useState([]);
  const [activeAnnouncementId, setActiveAnnouncementId] = useState(null);
  const [loadingIds, setLoadingIds] = useState([]);

  const modalItemRefs = useRef({});

  const showPopup = (e, message, id) => {
    if (!disableModal) {
      setShowModal(true);
      setActiveAnnouncementId(id);
    }
  };

  const markAsRead = (id) => {
    setLoadingIds((prev) => [...prev, id]);

    axiosInstance.post('/portal-announcement/status', { announcementId: id }).then(() => {
      setReadIds((prev) => [...prev, id]);
      setLoadingIds((prev) => prev.filter(loadingId => loadingId !== id));
    }).catch((error) => {
      console.error("Error updating announcement status:", error);
      setLoadingIds((prev) => prev.filter(loadingId => loadingId !== id));
    });
  };

  const getAnnouncements = useCallback(async () => {
    if (!axiosInstance?.get) return { error: "Axios not ready" };
    
    return axiosInstance.get('/portal-announcement').then(({data}) => {
      setAnnouncements(data.announcements);
        setReadAnnouncementIds(data.readAnnouncementIds);
      return { ok: true, data };
    }).catch((error) => {
      return { error };
    });
  }, [axiosInstance]);

  // const countAnnouncement = useMemo(
  //   () => announcements?.filter((announcement) => !readIds.includes(announcement.id)).length,
  //   [announcements, readIds]
  // );

  useEffect(() => {
    if (!idToken || !axiosInstance?.get) return;
  
    (async () => {
      await getAnnouncements();
      // Notify parent that announcements data has been loaded
      if (onDataLoaded) {
        onDataLoaded();
      }
    })();
  }, [getAnnouncements, axiosInstance, idToken, onDataLoaded]);

  useEffect(() => {
    if (showModal && activeAnnouncementId !== null) {
      const scrollTimeout = setTimeout(() => {
        const activeItem = modalItemRefs.current[activeAnnouncementId];
        if (activeItem) {
          activeItem.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 300);

      return () => clearTimeout(scrollTimeout);
    }
  }, [showModal, activeAnnouncementId]);

  // const Header = () => {
  //   return (
  //     <div className="relative">
  //       {announcements?.length > 0 && (
  //         <div className="absolute right-0 top-0 mt-2 mr-2 md:hidden block">
  //           <button className="bg-inherit border-none border-0" onClick={() => setShowModal(true)}>
  //             <ExpandIcon />
  //           </button>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // const Footer = () => {
  //   if (!announcements?.length) return null;

  //   return (
  //     <>
  //       {announcements?.length > 0 && (
  //         <button className="bg-inherit font-semibold border-none border-0 text-sm text-[#0D9488]" onClick={() => setShowModal(true)}>
  //           View All Announcements
  //           <ChevronRightIcon className="h-4 w-4 inline-block ml-1" />
  //         </button>
  //       )}
  //       {showModal && (
  //         <div
  //           className="fixed flex items-center justify-center top-0 left-0 w-screen h-screen bg-opacity-50 bg-gray-500 z-50"
  //           onClick={() => setShowModal(false)}>
  //           <div
  //             className="relative flex flex-col bg-white rounded-3xl overflow-auto px-10 min-h-[80vh] z-50 items-center shadow-md w-full max-w-2xl max-h-[calc(100%-100px)]"
  //             onClick={(e) => e.stopPropagation()}>
  //             <div className="w-full">
  //               <div className="text-3xl font-bold pt-8 pb-4 text-black">Announcements</div>
  //               <button onClick={() => setShowModal(false)} className="absolute top-5 right-5 text-black">
  //                 <XIcon className="w-5 h-5" />
  //               </button>
  //             </div>
  //             <div className="pb-5 w-full">
  //               {announcements?.length > 0 ? (
  //                 announcements?.map((announcement, index) => (
  //                   <AnnouncementModalItem
  //                     key={index}
  //                     {...announcement}
  //                     ref={(el) => (modalItemRefs.current[announcement.id] = el)}
  //                     activeAnnouncementId={activeAnnouncementId}
  //                   />
  //                 ))
  //               ) : (
  //                 <div className="text-xs text-[#1F2937] overflow-hidden text-ellipsis whitespace-pre-wrap line-clamp-2">
  //                   No Available Announcements
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </>
  //   );
  // };

  useEffect(() => {
    setReadIds(readAnnouncementIds);
  }, [readAnnouncementIds]);

  const getAnnouncementToShow = () => {
    if (!announcements?.length) return null;
    
    // First, try to find unread announcements (excluding locally read ones)
    const unreadAnnouncements = announcements.filter((announcement) => 
      !readAnnouncementIds.includes(announcement.id) && !readIds.includes(announcement.id)
    );
    
    // If there are unread announcements, show the first one
    if (unreadAnnouncements.length > 0) {
      return unreadAnnouncements[0];
    }
    
    // If all announcements are read, return null to show nothing
    return null;
  };

  const announcementToShow = getAnnouncementToShow();

  // If there's no announcement to show (no unread announcements), return null to render nothing
  if (!announcementToShow) {
    return null;
  }

  return (
    <>
      <AnnouncementItem
        key={announcementToShow.id}
        {...announcementToShow}
        isRead={readIds?.includes(announcementToShow.id) || readAnnouncementIds.includes(announcementToShow.id)}
        isLoading={loadingIds.includes(announcementToShow.id)}
        showPopup={showPopup}
        markAsRead={markAsRead}
      />
      {showModal && !disableModal && (
        <div
          className="fixed flex items-center justify-center top-0 left-0 w-screen h-screen bg-opacity-50 bg-gray-500 z-50"
          onClick={() => setShowModal(false)}>
          <div
            className="relative flex flex-col bg-white rounded-3xl overflow-auto px-10 min-h-[80vh] z-50 items-center shadow-md w-full max-w-2xl max-h-[calc(100%-100px)]"
            onClick={(e) => e.stopPropagation()}>
            <div className="w-full">
              <div className="text-3xl font-bold pt-8 pb-4 text-[#0c6980]">Updates</div>
              <button onClick={() => setShowModal(false)} className="absolute top-5 right-5 text-black">
                <XIcon className="w-5 h-5" />
              </button>
            </div>
            <div className="pb-5 w-full">
              {announcements?.length > 0 ? (
                announcements?.map((announcement, index) => (
                  <AnnouncementModalItem
                    key={index}
                    {...announcement}
                    ref={(el) => (modalItemRefs.current[announcement.id] = el)}
                    activeAnnouncementId={activeAnnouncementId}
                    isRead={readIds?.includes(announcement.id) || readAnnouncementIds.includes(announcement.id)}
                    isLoading={loadingIds.includes(announcement.id)}
                    markAsRead={markAsRead}
                  />
                ))
              ) : (
                <div className="text-xs text-[#1F2937] overflow-hidden text-ellipsis whitespace-pre-wrap line-clamp-2">
                  No Available Announcements
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default Announcements;
